"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.groupForm.title': 'Agregar grupo',
    'whatsapp.groupForm.back': 'Volver',
    'whatsapp.groupForm.cancel': 'Cancelar',
    'whatsapp.groupForm.save': 'Guardar',
    'whatsapp.groupForm.name': 'Nombre del grupo',
    'whatsapp.groupForm.namePlaceholder': 'Ingrese nombre del grupo...',
    'whatsapp.groupForm.pinMessage': 'Mensaje fijado',
    'whatsapp.groupForm.pinMessagePlaceholder': 'Contenido del mensaje que se fijará en el grupo...',
    'whatsapp.groupForm.pinMessageHint': 'Con el seguimiento activado y el bot como administrador, este mensaje se fijará.',
    'whatsapp.groupForm.nameRequired': 'El nombre del grupo es obligatorio.',
    'whatsapp.groupForm.avatar': 'Avatar',
    'whatsapp.groupForm.selectAvatar': '-- Seleccionar avatar --',
    'whatsapp.groupForm.botInstruction': 'Instrucción del bot',
    'whatsapp.groupForm.botInstructionPlaceholder': 'Ingrese instrucciones para el bot de WhatsApp...',
    'whatsapp.groupForm.inviteMembers': 'Miembros a invitar',
    'whatsapp.groupForm.memberPlaceholder': 'Ingrese número de teléfono o @nombre de usuario...',
    'whatsapp.groupForm.addMember': 'Agregar miembro',
    'whatsapp.groupForm.noMembersYet': 'Aún no se han agregado miembros.',
    'whatsapp.groupForm.createSuccess': 'Grupo creado correctamente.',
    'whatsapp.groupForm.createFailed': 'Error al crear el grupo.',
};
